import { Palette } from '@mui/material'

export const headerStyle = (palette: Palette) => ({
	fontFamily: '"Eczar", serif',
	fontSize: '44px',
	color: palette.text.darkBlue,
	fontWeight: '500',
})
